import { Grid, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { maskPhone, normalizeEmailInput, PHONE_MASK_PLACEHOLDER } from "../../utils/inputMasks";
import { SignUpFieldProps } from "./model";

const UserFields = ({ userData, setUserData }: SignUpFieldProps) => (
  <>
    <Grid item xs={12} md={12}>
      <FormControl fullWidth sx={{ m: 1 }}>
        <TextField
          id="outlined-basic3"
          label="Email"
          type="email"
          variant="outlined"
          inputProps={{ inputMode: "email" }}
          onChange={(e) => {
            setUserData({
              ...userData,
              email: normalizeEmailInput(e.target.value),
            });
          }}
          value={userData.email}
        />
      </FormControl>
    </Grid>
    <Grid item xs={12} md={12}>
      <FormControl fullWidth sx={{ m: 1 }}>
        <TextField
          id="outlined-basic3"
          label="Номер телефона"
          variant="outlined"
          placeholder={PHONE_MASK_PLACEHOLDER}
          inputProps={{ inputMode: "numeric", maxLength: PHONE_MASK_PLACEHOLDER.length }}
          onChange={(e) => {
            setUserData({
              ...userData,
              phone: maskPhone(e.target.value),
            });
          }}
          value={userData.phone}
        />
      </FormControl>
    </Grid>
    <Grid item xs={12} md={12}>
      <FormControl fullWidth sx={{ m: 1 }}>
        <TextField
          id="outlined-basic3"
          label="Пароль"
          type="password"
          variant="outlined"
          onChange={(e) => {
            setUserData({
              ...userData,
              password: e.target.value,
            });
          }}
          value={userData.password}
        />
      </FormControl>
    </Grid>
    <Grid item xs={12} md={12}>
      <FormControl fullWidth sx={{ m: 1 }}>
        <TextField
          id="outlined-basic3"
          label="Повторите пароль"
          type="password"
          variant="outlined"
          onChange={(e) => {
            setUserData({
              ...userData,
              password2: e.target.value,
            });
          }}
          value={userData.password2}
        />
      </FormControl>
    </Grid>
  </>
);

export default UserFields;
